import { create } from 'zustand';
import type { AppMode, ToolId } from './types';

interface AioStore {
  mode: AppMode;
  query: string;
  activeTool: ToolId | null;
  favoriteIds: string[];
  authenticated: boolean;
  setMode: (mode: AppMode) => void;
  setQuery: (query: string) => void;
  setActiveTool: (tool: ToolId | null) => void;
  setFavorites: (ids: string[]) => void;
  toggleFavorite: (id: string) => void;
  setAuthenticated: (authenticated: boolean) => void;
}

export const useAioStore = create<AioStore>((set) => ({
  mode: 'standalone',
  query: '',
  activeTool: null,
  favoriteIds: [],
  authenticated: false,
  setMode: (mode) => set({ mode }),
  setQuery: (query) => set({ query }),
  setActiveTool: (activeTool) => set({ activeTool }),
  setFavorites: (favoriteIds) => set({ favoriteIds }),
  toggleFavorite: (id) => set((state) => ({ favoriteIds: state.favoriteIds.includes(id) ? state.favoriteIds.filter((item) => item !== id) : [...state.favoriteIds, id] })),
  setAuthenticated: (authenticated) => set({ authenticated }),
}));
